import teamProjectApi from "../../api/rest/teamProjectApi"
import {EReviewStatus} from "../../const/dataEnum";
import {showAlert} from "../../lib/utilities";

const getProjectByEmployeeId = async (employeeId) => {
  const data = await teamProjectApi.getProjectByEmployeeId(employeeId);
  if (data) {
    return data;
  }
  return null;
}

const getOngoingRevieweeWithProject = async (reviewees) => {
  let newReviewees = [...reviewees];

  const promises = [];
  const ongoingReviewRevieweeIds = reviewees.filter((review) => review.status === EReviewStatus.ONGOING).map((review) => review.id);

  ongoingReviewRevieweeIds.forEach(async (id) => {
    promises.push(manageAssignmentBusiness.getProjectByEmployeeId(id));
  })

  const employeeProjects = await Promise.all(promises);

  employeeProjects.forEach((project, index) => {
    if (project) {
      const revieweeId = ongoingReviewRevieweeIds[index];
      const filteredReviewee = newReviewees.find((reviewee) => reviewee.id === revieweeId);
      filteredReviewee.projects = project.map((pr) => ({
        id: pr.project.id,
        text: pr.project.projectName,
        group: '',
      }));
    }
  });

  return newReviewees;
}

const getReviewersWithRevieweeProject = (reviweeId, reviewers) => async (dispatch) => {
  const employeeProjects = await getProjectByEmployeeId(reviweeId);

  if (!employeeProjects) {
    dispatch(showAlert(employeeProjects, null, 'Reviewee does not have project'));
  }

  const newReviewers = reviewers.map((reviewer) => {
    if (reviewer.status === EReviewStatus.ONGOING) {
      return {
        ...reviewer,
        projects: employeeProjects ? employeeProjects.map((pr) => ({
          id: pr.project.id,
          text: pr.project.projectName,
          group: '',
        })) : [],
      }
    }
    return reviewer;
  });

  return newReviewers;
}

const getProjectName = (projectId, projectState) => {
  const selectedProject = projectState.find((pj) => pj.id === projectId);
  if (selectedProject) {
    return selectedProject?.text;
  }
  return 'No Project';
}

/**
 * @param {number} employeeId 
 * @param {number} periodId 
 * @returns {Promise<Array>}
 */
const getEmployeeProjectsByPeriod = async (employeeId, periodId) => {
  const data = await teamProjectApi.getEmployeeProjectsByPeriod(employeeId, periodId);
  if (data) {
    return data;
  }
  return [];
}

const manageAssignmentBusiness = {
  getProjectByEmployeeId,
  getOngoingRevieweeWithProject,
  getProjectName,
  getReviewersWithRevieweeProject,
  getEmployeeProjectsByPeriod,
}

export default manageAssignmentBusiness